/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import { TokenAmount, TokenAmountFromJSON, TokenAmountFromJSONTyped, TokenAmountToJSON } from './TokenAmount'

/**
 *
 * @export
 * @interface PoolTransactionTokenAmounts
 */
export interface PoolTransactionTokenAmounts {
  /**
   *
   * @type {TokenAmount}
   * @memberof PoolTransactionTokenAmounts
   */
  lpToken?: TokenAmount
  /**
   *
   * @type {TokenAmount}
   * @memberof PoolTransactionTokenAmounts
   */
  token0?: TokenAmount
  /**
   *
   * @type {TokenAmount}
   * @memberof PoolTransactionTokenAmounts
   */
  token1?: TokenAmount
  /**
   *
   * @type {TokenAmount}
   * @memberof PoolTransactionTokenAmounts
   */
  stakingToken?: TokenAmount
  /**
   *
   * @type {TokenAmount}
   * @memberof PoolTransactionTokenAmounts
   */
  rewardToken?: TokenAmount
}

export function PoolTransactionTokenAmountsFromJSON(json: any): PoolTransactionTokenAmounts {
  return PoolTransactionTokenAmountsFromJSONTyped(json, false)
}

export function PoolTransactionTokenAmountsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PoolTransactionTokenAmounts {
  if (json === undefined || json === null) {
    return json
  }
  return {
    lpToken: !exists(json, 'lpToken') ? undefined : TokenAmountFromJSON(json['lpToken']),
    token0: !exists(json, 'token0') ? undefined : TokenAmountFromJSON(json['token0']),
    token1: !exists(json, 'token1') ? undefined : TokenAmountFromJSON(json['token1']),
    stakingToken: !exists(json, 'stakingToken') ? undefined : TokenAmountFromJSON(json['stakingToken']),
    rewardToken: !exists(json, 'rewardToken') ? undefined : TokenAmountFromJSON(json['rewardToken']),
  }
}

export function PoolTransactionTokenAmountsToJSON(value?: PoolTransactionTokenAmounts | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    lpToken: TokenAmountToJSON(value.lpToken),
    token0: TokenAmountToJSON(value.token0),
    token1: TokenAmountToJSON(value.token1),
    stakingToken: TokenAmountToJSON(value.stakingToken),
    rewardToken: TokenAmountToJSON(value.rewardToken),
  }
}
